import React from 'react';
import { Row, Col, Button } from '../../../legacy/hui/src/styled/';
import styled from 'styled-components';
import { Theme } from '../Bunnings/Theme';
import { darken } from 'polished/lib/index';
import { ErrorText } from '../Field';
import { Field, reduxForm, Form } from 'redux-form';
import PropTypes from 'prop-types';
import Cleave from 'cleave.js/react';
import { formatDate, parseDate } from 'react-day-picker/moment';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import dateIcon from '../../images/purchase-icon.svg';
import { voucherValidation, pdateValidation } from '../../utils/validation';

const TitleText = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: #434447;
  white-space: nowrap;
  font-family: roboto !important;
`;

const ButtonSubmit = Button.extend`
  color: #fff;
  font-size: 14px;
  padding: 8px 30px;
  background-color: ${Theme.primary};
  &:active,
  &:hover,
  &:focus {
    background-color: ${darken(0.1, Theme.primary)};
  }
`;

const InputWrapper = styled.div`
  input {
    border-radius: 5px;
    padding: 12px 15px;
    width: 100%;
    outline: none;
    text-align: center;
    font-size: 16px;
  }
  &.errorBorder input {
    border: 1px solid #ca3121;
  }
  &.normalBorder input {
    border: 1px solid #a1a1a3;
  }
`;

const DayPickerInputWrapper = styled.div`
  position: relative;
  .DayPickerInput {
    width: 100%;
  }

  input {
    width: 100%;
    font-size: 16px;
    appearance: none;
    outline: 0;
    border-radius: 5px;
    padding: 12px 15px 12px 45px;
    background-image: url(${dateIcon});
    background-repeat: no-repeat;
    background-position: left 10px center;
  }
  &.errorBorder input {
    border: 1px solid #ca3121;
  }
  &.normalBorder input {
    border: 1px solid #a1a1a3;
  }
`;

const DatePickField = ({ input, meta }) => (
  <DayPickerInputWrapper className={meta.error && meta.touched ? 'errorBorder' : 'normalBorder'}>
    <DayPickerInput
      format="DD/MM/YYYY"
      inputProps={{ ...input }}
      placeholder="DD/MM/YYYY"
      formatDate={formatDate}
      parseDate={parseDate}
      onDayChange={day => {
        input.onChange(formatDate(day));
      }}
    />
    {meta.error && meta.touched && typeof meta.error === 'string' && (
      <ErrorText style={{ fontSize: 11, paddingBottom: 0 }}>{meta.error}</ErrorText>
    )}
  </DayPickerInputWrapper>
);
DatePickField.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object
};

const renderCleaveField = ({ input, meta }) => (
  <InputWrapper className={meta.error && meta.touched ? 'errorBorder' : 'normalBorder'}>
    <Cleave
      {...input}
      placeholder="XXXX - XXXX - XXXX - XX"
      options={{ blocks: [4, 4, 4, 2], delimiter: ' - ', uppercase: true }}
    />
    {meta.error && meta.touched && typeof meta.error === 'string' && (
      <ErrorText style={{ fontSize: 11, paddingBottom: 0 }}>{meta.error}</ErrorText>
    )}
  </InputWrapper>
);
renderCleaveField.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object
};

const errorMessage = ({ meta }) => {
  return meta.error ? <ErrorText style={{ fontSize: 11 }}>{meta.error}</ErrorText> : null;
};
errorMessage.propTypes = {
  meta: PropTypes.object
};

const ExtraInstallForm = ({ handleSubmit }) => (
  <Form onSubmit={handleSubmit} autoComplete="new-password">
    <Row mt={0}>
      <Col xs={12} lg={8} style={{ color: '#7B7C7E', fontSize: '12px', lineHeight: '18px' }}>
        If you have bought more than one toilet (with an install service for each toilet) you can
        add more toilets to this job. All the toilets in this job will be installed at the same time
        by the same plumber.
      </Col>
    </Row>
    <Row mt={0.63}>
      <Col xs={12} md={4.8} lg={4}>
        <TitleText>Install Code</TitleText>
      </Col>
      <Col xs={0} md={4.8} lg={4}>
        <TitleText>Purchase Date</TitleText>
      </Col>
    </Row>
    <Row>
      <Col xs={12} md={4.8} lg={4} mt={0.63}>
        <Field
          name="extra_install_voucher"
          component={renderCleaveField}
          validate={[voucherValidation]}
        />
      </Col>
      <Col xs={12} md={0} mt={0.63}>
        <TitleText>Purchase Date</TitleText>
      </Col>
      <Col xs={12} md={4.8} lg={4} mt={0.63}>
        <Field
          name="pdate"
          component={DatePickField}
          validate={[pdateValidation]}
          autoComplete="new-password"
        />
      </Col>
      <Col xs={0} md={2.4} lg={4} mt={0.63}>
        <div style={{ display: 'flex', height: 44, alignItems: 'center' }}>
          <ButtonSubmit>Add</ButtonSubmit>
        </div>
      </Col>
    </Row>
    <Row mt={0}>
      <Col xs={12}>
        <Field name="extra_install_voucher_error" component={errorMessage} />
      </Col>
      <Col xs={12} md={0} mt={1}>
        <ButtonSubmit>Add</ButtonSubmit>
      </Col>
    </Row>
    <Row mt={0.63}>
      <Col xs={12} style={{ color: '#7B7C7E', fontSize: '12px', lineHeight: '18px' }}>
        If you want the additional toilet installed at a different address you will need to create a
        new job.
      </Col>
    </Row>
  </Form>
);

ExtraInstallForm.propTypes = {
  handleSubmit: PropTypes.func
};

export default reduxForm({
  form: 'ExtraInstallForm'
})(ExtraInstallForm);
